import { CarouselItemModel, InsightItemModel, InsightsFeaturedModel } from '@_types/organisms';
import { getModifiers } from '@helpers/functions';
import Carousel from '@organisms/carousel/Carousel';
import { InsightExtendsView, InsightView } from '@helpers/consts';

import InsightItem from './InsightItem';
import InsightsGrid from './InsightsGrid';
import InsightTheViewFeaturedItem from './InsightTheViewFeaturedItem';

const InsightsFeatured = (model: InsightsFeaturedModel) => {
  const styleModifiers = getModifiers(model, 'kf-o-insights-featured');
  const { list, carouselDesktop, readMore, view, extendsView, theviewOptions } = model;

  const calcViewParams = () => {
    let featuredItems: CarouselItemModel[] | undefined = list?.items?.slice(0, 4);
    let gridItems: CarouselItemModel[] | undefined = list?.items?.slice(4);
    let carouselItemsMobile: CarouselItemModel[] | undefined = (() => (!carouselDesktop ? list?.items?.slice(1, 4) : list?.items?.slice(1)))();
    let extendClass: NonNullable<InsightItemModel['styleModifier']>[0] = 'horizontal-desktop';

    switch (view) {
      case InsightView.FEATURED:
        extendClass = 'horizontal';
        break;

      case InsightView.FEATURED_2:
        featuredItems = list?.items;
        gridItems = undefined;
        carouselItemsMobile = undefined;
        extendClass = 'secondary';

        break;

      case InsightView.FEATURED_2_GRID_3:
        featuredItems = list?.items?.slice(0, 2);
        carouselItemsMobile = (() => (list?.items && list?.items?.length > 2 ? list?.items?.slice(2) : undefined))();
        gridItems = carouselItemsMobile && carouselItemsMobile.length ? [...carouselItemsMobile] : undefined;
        extendClass = 'secondary';
        break;

      default:
        break;
    }

    return {
      featuredItems,
      gridItems,
      carouselItemsMobile,
      extendClass,
    };
  };

  const { featuredItems, gridItems, carouselItemsMobile, extendClass } = calcViewParams();

  const hasGridItems = (() => gridItems && !!gridItems.length)();
  const hasCarouselItemsMobile = (() => carouselItemsMobile && !!carouselItemsMobile.length)();

  const renderForFeaturedTheView = () => {
    const numberOfFeaturedItems = theviewOptions?.featuredquantity || 4;
    const featuredItemsTheView = list?.items?.slice(0, numberOfFeaturedItems);
    const gridItemsTheView = list?.items?.slice(numberOfFeaturedItems);
    const listGrid = { ...list, items: gridItemsTheView };

    return (
      <div className={styleModifiers}>
        <div className="kf-container">
          <div className="kf-o-insights-featured__featured">
            {featuredItemsTheView?.map((item, index) => (
              <InsightTheViewFeaturedItem
                key={index}
                {...item.insight}
                styleModifier={[
                  ...(item.insight?.styleModifier || []),
                  ...((theviewOptions?.featuredfirstviewlayout === 'left' ? index % 2 !== 0 : index % 2 === 0) ? ['image-right' as const] : []),
                ]}
              />
            ))}
          </div>
        </div>

        {gridItemsTheView && gridItemsTheView.length > 0 && (
          <>
            {extendsView === InsightExtendsView.CAROUSEL && (
              <div className="kf-o-insights-featured__carousel" data-is-mobile="true">
                {list && <Carousel {...list} items={gridItemsTheView} spaceBetween={13} />}
              </div>
            )}

            {extendsView === InsightExtendsView.CAROUSEL ? (
              <div className="kf-container">
                <div className="kf-o-insights-featured__carousel" data-is-desktop="true">
                  {list && <Carousel {...list} items={gridItemsTheView} spaceBetween={13} />}
                </div>
              </div>
            ) : (
              <InsightsGrid list={listGrid} readMore={readMore} />
            )}
          </>
        )}
      </div>
    );
  };

  if (view === InsightView.FEATURED_THE_VIEW) {
    return renderForFeaturedTheView();
  }

  return (
    <div className={styleModifiers}>
      <div className="kf-container">
        <div className="kf-o-insights-featured__featured">
          {featuredItems?.map((item, index) => (
            <InsightItem
              key={index}
              {...item.insight}
              styleModifier={
                (index > 0 && (item.insight?.styleModifier ? [...item.insight.styleModifier, extendClass] : [extendClass])) || ['primary']
              }
            />
          ))}
        </div>
      </div>

      {(view === InsightView.FEATURED || extendsView === InsightExtendsView.CAROUSEL || view == InsightView.FEATURED_2_GRID_3) &&
        hasCarouselItemsMobile && (
          <div className="kf-o-insights-featured__carousel" data-is-mobile="true">
            {list && carouselItemsMobile && <Carousel {...list} items={carouselItemsMobile} />}
          </div>
        )}

      {hasGridItems &&
        view !== InsightView.FEATURED_2_GRID_3 &&
        (carouselDesktop ? (
          <div className="kf-container">
            <div className="kf-o-insights-featured__carousel" data-is-desktop="true">
              {list && <Carousel {...list} items={gridItems} />}
            </div>
          </div>
        ) : (
          <InsightsGrid list={list} readMore={readMore} />
        ))}
      {hasGridItems && view === InsightView.FEATURED_2_GRID_3 && <InsightsGrid list={{ ...list, items: gridItems }} readMore={readMore} />}
    </div>
  );
};

export default InsightsFeatured;
